import { MerchantStatusEnum } from "../../constants/user";

export const formatPhoneNumber = (text: string, phoneCode: string) => {
  return `(${phoneCode}) ${text}`;
};

export function mapAccountInformationWhenHasUpdateRequest(data: any) {
  return {
    documents: data.information.merchantApprovals.documents,
    name: data.information.merchantApprovals.name,
    email: data.information.merchantApprovals.email,
    phone: Number(data.information.merchantApprovals.phone?.replace("+65", "").replace("+84", "")),
    registeredOfficeAddress: data.information.merchantApprovals.registeredOfficeAddress,
    sfaNumber: data.information.merchantApprovals.sfaNumber,
    gstRegistrationNumber: data.information.merchantApprovals.gstRegistrationNumber,
    representativeName: data.information.merchantApprovals.representativeName,
    contactOfficeNo: data.information.merchantApprovals.contactOfficeNo,
    territory: data.information.merchantApprovals.territory,
    businessNature: data.information.merchantApprovals.businessNature,
    contactEmailAddress: data.information.merchantApprovals.contactEmailAddress,
    contactMobileNo: data.information.merchantApprovals.contactMobileNo,
    financeRepresentativeName: data.information.merchantApprovals.financeRepresentativeName,
    bankOfficeNo: data.information.merchantApprovals.bankOfficeNo,
    bankMobileNo: data.information.merchantApprovals.bankMobileNo,
    bankEmailAddress: data.information.merchantApprovals.bankEmailAddress,
    bankName: data.information.merchantApprovals.bankName,
    accountNo: data.information.merchantApprovals.accountNo,
    accountName: data.information.merchantApprovals.accountName,
    region: data.information.merchantApprovals.phoneCode,
  };
}

export function mapAccountInformationWhenHasNoUpdateRequest(data: any) {
  return {
    documents: data.information.documents,
    name: data.information.name,
    email: data.information.merchantUser.email,
    phone: Number(data.information.merchantUser.phone.replace("+65", "").replace("+84", "")),
    registeredOfficeAddress: data.information.merchantContact.registeredOfficeAddress,
    sfaNumber: data.information.merchantContact.sfaNumber,
    gstRegistrationNumber: data.information.merchantContact.gstRegistrationNumber,
    representativeName: data.information.merchantContact.representativeName,
    contactOfficeNo: data.information.merchantContact.officeNo,
    territory: data.information.merchantContact.territory,
    businessNature: data.information.merchantContact.businessNature,
    contactEmailAddress: data.information.merchantContact.emailAddress,
    contactMobileNo: data.information.merchantContact.mobileNo,
    financeRepresentativeName: data.information.merchantBankDetail.financeRepresentativeName,
    bankOfficeNo: data.information.merchantBankDetail.officeNo,
    bankMobileNo: data.information.merchantBankDetail.mobileNo,
    bankEmailAddress: data.information.merchantBankDetail.emailAddress,
    bankName: data.information.merchantBankDetail.bankName,
    accountNo: data.information.merchantBankDetail.accountNo,
    accountName: data.information.merchantBankDetail.accountName,
    region: data.information.merchantUser.phoneCode,
  };
}

export function mapAccountInformation(data: any) {
  if (!data)
    return {
      arrayAccountInformation: [],
      arrayMerchantInformation: [],
      arrayPaymentDetails: [],
      merchantStatus: MerchantStatusEnum.ACTIVE,
    };
  //case update rejected
  // if (data.information.merchantApprovals) {
  //   return {
  //     arrayAccountInformation: [
  //       {
  //         title: "Full name",
  //         value: data?.information?.merchantApprovals?.name,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(RejectedFieldUpdate.NAME),
  //       },
  //       {
  //         title: "Email",
  //         value: data?.information?.merchantApprovals?.email,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(RejectedFieldUpdate.EMAIL),
  //       },
  //       {
  //         title: "Phone number",
  //         value: formatPhoneNumber(
  //           data?.information?.merchantApprovals?.phone,
  //           data?.information?.merchantApprovals?.phoneCode
  //         ),
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(RejectedFieldUpdate.PHONE),
  //       },
  //     ],
  //     arrayMerchantInformation: [
  //       {
  //         title: "Registered Office Address",
  //         value: data?.information?.merchantApprovals?.registeredOfficeAddress,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(
  //           RejectedFieldUpdate.REGISTERED_OFFICE_ADDRESS
  //         ),
  //       },
  //       {
  //         title: "SFA Number",
  //         value: data?.information?.merchantApprovals?.sfaNumber,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(RejectedFieldUpdate.SFA_NUMBER),
  //       },
  //       {
  //         title: "GST Registration Number",
  //         value: data?.information?.merchantApprovals?.gstRegistrationNumber,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(
  //           RejectedFieldUpdate.GST_REGISTRATION_NUMBER
  //         ),
  //       },
  //       {
  //         title: "Representative Name",
  //         value: data?.information?.merchantApprovals?.representativeName,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(
  //           RejectedFieldUpdate.REPRESENTATIVE_NAME
  //         ),
  //       },
  //       {
  //         title: "Office No",
  //         value: data?.information?.merchantApprovals?.contactOfficeNo,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(
  //           RejectedFieldUpdate.CONTACT_OFFICE_NO
  //         ),
  //       },
  //       {
  //         title: "Territory",
  //         value: data?.information?.merchantApprovals?.territory,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(RejectedFieldUpdate.TERRITORY),
  //       },
  //       {
  //         title: "Business Nature",
  //         value: data?.information?.merchantApprovals?.businessNature,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(RejectedFieldUpdate.BUSINESS_NATURE),
  //       },
  //       // {
  //       //   title: "Email address",
  //       //   value: data?.information?.merchantApprovals?.contactEmailAddress,
  //       //   isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(
  //       //     RejectedFieldUpdate.CONTACT_EMAIL_ADDRESS
  //       //   ),
  //       // },
  //       {
  //         title: "Mobile No",
  //         value: data?.information?.merchantApprovals?.contactMobileNo,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(
  //           RejectedFieldUpdate.CONTACT_MOBILE_NO
  //         ),
  //       },
  //     ],
  //     arrayPaymentDetails: [
  //       {
  //         title: "Finance Representative Name",
  //         value: data?.information?.merchantApprovals?.financeRepresentativeName,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(
  //           RejectedFieldUpdate.FINANCE_REPRESENTATIVE_NAME
  //         ),
  //       },
  //       {
  //         title: "Office No",
  //         value: data?.information?.merchantApprovals?.bankOfficeNo,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(RejectedFieldUpdate.BANK_OFFICE_NO),
  //       },
  //       {
  //         title: "Mobile No",
  //         value: data?.information?.merchantApprovals?.bankMobileNo,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(RejectedFieldUpdate.BANK_MOBILE_NO),
  //       },
  //       {
  //         title: "Email Address",
  //         value: data?.information?.merchantApprovals?.bankEmailAddress,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(
  //           RejectedFieldUpdate.BANK_EMAIL_ADDRESS
  //         ),
  //       },
  //       {
  //         title: "Bank Name",
  //         value: data?.information?.merchantApprovals?.bankName,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(RejectedFieldUpdate.BANK_NAME),
  //       },
  //       {
  //         title: "Account Number",
  //         value: data?.information?.merchantApprovals?.accountNo,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(RejectedFieldUpdate.ACCOUNT_NO),
  //       },
  //       {
  //         title: "Acount Name",
  //         value: data?.information?.merchantApprovals?.accountName,
  //         isReject: data?.information?.merchantApprovals?.rejectedFields?.includes(RejectedFieldUpdate.ACCOUNT_NO),
  //       },
  //     ],
  //     merchantStatus: data?.information?.status,
  //   };
  // } else {
  return {
    arrayAccountInformation: [
      {
        title: "Full name",
        value: data?.information?.name,
        isReject: false,
      },
      {
        title: "Email",
        value: data?.information?.merchantUser?.email,
        isReject: false,
      },
      {
        title: "Phone number",
        value: formatPhoneNumber(data?.information?.merchantUser?.phone, data?.information?.merchantUser?.phoneCode),
        isReject: false,
      },
    ],
    arrayMerchantInformation: [
      {
        title: "Registered Office Address",
        value: data?.information?.merchantContact?.registeredOfficeAddress,
        isReject: false,
      },
      {
        title: "SFA Number",
        value: data?.information?.merchantContact?.sfaNumber,
        isReject: false,
      },
      {
        title: "UEN Number",
        value: data?.information?.merchantContact?.uenNumber,
        isReject: false,
      },
      {
        title: "GST",
        value: data?.information?.merchantContact?.isGstRegistration ? "Yes" : "No",
        isReject: false,
      },
      {
        title: "Representative Name",
        value: data?.information?.merchantContact?.representativeName,
        isReject: false,
      },
      {
        title: "Office No",
        value: data?.information?.merchantContact?.officeNo,
        isReject: false,
      },
      {
        title: "Territory",
        value: data?.information?.merchantContact?.territory,
        isReject: false,
      },
      {
        title: "Business Nature",
        value: data?.information?.merchantContact?.businessNature,
        isReject: false,
      },
      // {
      //   title: "Email address",
      //   value: data?.information?.merchantContact?.emailAddress,
      //   isReject: false,
      // },
      {
        title: "Mobile No",
        value: data?.information?.merchantContact?.mobileNo,
        isReject: false,
      },
    ],
    arrayPaymentDetails: [
      {
        title: "Finance Representative Name",
        value: data?.information?.merchantBankDetail?.financeRepresentativeName,
        isReject: false,
      },
      {
        title: "Office No",
        value: data?.information?.merchantBankDetail?.officeNo,
        isReject: false,
      },
      {
        title: "Mobile No",
        value: data?.information?.merchantBankDetail?.mobileNo,
        isReject: false,
      },
      {
        title: "Email Address",
        value: data?.information?.merchantBankDetail?.emailAddress,
        isReject: false,
      },
      {
        title: "Bank Name",
        value: data?.information?.merchantBankDetail?.bankName,
        isReject: false,
      },
      {
        title: "Account Number",
        value: data?.information?.merchantBankDetail?.accountNo,
        isReject: false,
      },
      {
        title: "Acount Name",
        value: data?.information?.merchantBankDetail?.accountName,
        isReject: false,
      },
    ],
    merchantStatus: data?.information?.status,
    // };
  };
}
